// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__2rOWW","chart":"style_chart__14eOj","resultsTitle":"style_resultsTitle__3BFai","title":"style_title__3lDyh","words":"style_words__REN8a"};